const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
console.log('[clients.js] API_BASE =', API_BASE);

/** Public — landing page (active clients only) */
export const fetchClients = async () => {
  const res = await fetch(`${API_BASE}/api/clients`);
  if (!res.ok) throw new Error('Failed to fetch clients');
  return res.json();
};

/** Admin — all clients including inactive */
export const fetchAllClients = async (token) => {
  const res = await fetch(`${API_BASE}/api/clients/admin`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Failed to fetch clients');
  return res.json();
};

/** Admin — create (FormData with logo file) */
export const createClient = async (formData, token) => {
  console.log('[createClient] token present:', !!token);
  console.log('[createClient] FormData entries:');
  for (const [k, v] of formData.entries()) {
    console.log('  ', k, '→', v instanceof File ? `File(${v.name}, ${v.size} bytes, ${v.type})` : v);
  }

  const res = await fetch(`${API_BASE}/api/clients`, {
    method:  'POST',
    headers: { Authorization: `Bearer ${token}` },
    body:    formData,
  });

  console.log('[createClient] response status:', res.status);

  if (res.status === 413) throw new Error('File too large — ask your server admin to increase client_max_body_size in Nginx.');
  const text = await res.text();
  console.log('[createClient] response body:', text.slice(0, 300));
  let data;
  try { data = JSON.parse(text); } catch { throw new Error(`Server error (${res.status}): ${text.slice(0, 200)}`); }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

/** Admin — update (FormData; logo optional) */
export const updateClient = async (id, formData, token) => {
  console.log('[updateClient] id:', id, '| token present:', !!token);
  console.log('[updateClient] FormData entries:');
  for (const [k, v] of formData.entries()) {
    console.log('  ', k, '→', v instanceof File ? `File(${v.name}, ${v.size} bytes, ${v.type})` : v);
  }

  const res = await fetch(`${API_BASE}/api/clients/${id}`, {
    method:  'PUT',
    headers: { Authorization: `Bearer ${token}` },
    body:    formData,
  });

  console.log('[updateClient] response status:', res.status);

  if (res.status === 413) throw new Error('File too large — ask your server admin to increase client_max_body_size in Nginx.');
  const text = await res.text();
  console.log('[updateClient] response body:', text.slice(0, 300));
  let data;
  try { data = JSON.parse(text); } catch { throw new Error(`Server error (${res.status}): ${text.slice(0, 200)}`); }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

/** Admin — delete */
export const deleteClient = async (id, token) => {
  const res = await fetch(`${API_BASE}/api/clients/${id}`, {
    method:  'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to delete client');
  return data;
};
